import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const createRepeatOrder = createAsyncThunk(
  "order/repeat/create",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.createRepeatOrder}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const updateRepeatOrder = createAsyncThunk(
  "order/repeat/update",
  async (obj: any, { rejectWithValue }) => {
    const { axiosPut } = useCustomAxios();
    let url = API_ENDPOINTS.updateRepeatOrder;
    url = url.replace(":roId", obj.id);
    try {
      const response = await axiosPut(url, obj.body);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const getROList = createAsyncThunk(
  "getROList",
  async (parameter: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getRepeatOrder;

    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getRepeatOrderById = createAsyncThunk(
  "get/ro/id",
  async (id: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getRepeatOrderById}`;
    url = url.replace(":roId", id);
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const acceptRO = createAsyncThunk(
  "ro/accept",
  async (obj: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.acceptRepeatOrder}`;
    url = url.replace(":roId", obj?.id);
    try {
      const response = await axiosPost(url, obj?.body);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);